const baseConfig = {
	apiRoot: 'https://app.iqilu.com',
	// apiRoot: 'http://chuangqi.test.qiludev.com'
}

export default baseConfig;